// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import KonvoNotificationPrefs from '@app/features/konvo_notifications/state/KonvoNotificationPrefs';

export function handleKonvoNotificationPrefsUpdate(data: unknown, _context: GatewayHandlerContext): void {
	if (!data || typeof data !== 'object') return;
	KonvoNotificationPrefs.applyRemote(data as Parameters<typeof KonvoNotificationPrefs.applyRemote>[0]);
}
